<template>
<div>

  detail {{$route.query.id}}
</div>
</template>

<script>
export default {
  name: "detail",
  mounted() {
    console.log(this.$route)
  }
}
</script>

<style scoped>

</style>